'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const getDefaultColumns = (data) => {
    if (data.length === 0) {
        return [];
    }
    return Object.keys(data[0]).reduce((prev, key) => {
        if (key === 'subRows') {
            return prev;
        }
        const column = {
            accessorKey: key,
            cell: (info) => React__namespace.createElement("span", null, info.getValue()),
            footer: (props) => props.column.id,
        };
        prev.push(column);
        return prev;
    }, []);
};

exports.getDefaultColumns = getDefaultColumns;
//# sourceMappingURL=getDefaultColumns.js.map
